<!-- @format -->

<app-progress-bar [currentStep]="currentProgressStep$ | async" [submissionInReview]="submissionPageViewed"
	(goToPage)="goToStep($event)" (goToBeginning)="purgeProgress()"
	*ngIf="currentProgressStep !== 1.5 && currentProgressStep !== 6 && currentProgressStep !== 7">
</app-progress-bar>

<ng-container *ngIf="currentProgressStep === 1">
	<app-problem-selection [problemMenuItems]="problemMenuItems" [filteredProblemsItemCount]="filteredProblemsItemCount"
		[commonSearches]="commonSearches" [selectedProblemItem]="selectedProblemMenuItem"
		(updatedProblemMenu)="updateProblemMenuDropDownState($event)"
		(selectedProblemMenuItem)="setSelectedProblemMenuItem($event)"
		(filterProblemMenuItems)="filterProblemMenuItems($event)" (logSearchFieldText)="logSearchFieldText($event)"
		(goToNextPage)="goToNextStep()" (triggerProblemIndexSetter)="setProbSelectButtonTabIndex()"
		(triggerIframeExpansion)="triggerIframeExpansion()" (triggerIframeContraction)="triggerIframeContraction()">
	</app-problem-selection>
	<div class="navButton problemSelectionStep" id="navBtn">
		<div>
			<button class="reviewSubmissionBtn" (click)="goToStep(5)" id="problemSelectReviewSub"
				*ngIf="submissionPageViewed" [disabled]="showRedirectionMsg">
				Review
			</button>
			<!-- <button
                class="NextBtn" (click)="goToNextStep()" id="problemSelectNextPage"
                [disabled]="selectedProblemMenuItem!.ProblemMenuConfig_RefId === 0">
                Next &gt;
            </button> -->
		</div>
	</div>
</ng-container>

<ng-container *ngIf="currentProgressStep === 1.3">
	<app-problem-message-info [selectedProblemMenuItem]="selectedProblemMenuItem"
		[showRedirectionMsg]="showRedirectionMsg" [showIsUrgentPrompt]="showIsUrgentPrompt"></app-problem-message-info>


	<div class="navButton" id="navBtn-msg-info" *ngIf="!showRedirectionMsg">
		<button class="backBtn" (click)="goToStep(1)">&lt; Back</button>
		<button class="NextBtn" (click)="goToStep(2)">Continue</button>
	</div>

	<div class="navButton" id="navBtn" *ngIf="showRedirectionMsg">
		<button class="NextBtn startOverBtn" (click)="purgeProgress()">Start over</button>
	</div>

	<div *ngIf="showRelatedLinks">
		<div class="links-title">Related Links</div>
		<div class="links" *ngFor="let link of relatedLinks" [innerHTML]="link"></div>
	</div>
</ng-container>

<ng-container *ngIf="currentProgressStep === 1.5">
	<app-problem-message-error [selectedProblemMenuItem]="selectedProblemMenuItem"
		[showRedirectionMsg]="showRedirectionMsg" [showIsUrgentPrompt]="showIsUrgentPrompt"></app-problem-message-error>

	<div class="navButton" id="navBtn" *ngIf="!showRedirectionMsg">
		<button class="NextBtn" (click)="goToNextStep()">Continue</button>
	</div>

	<div class="navButton" id="navBtn" *ngIf="showRedirectionMsg">
		<button class="NextBtn startOverBtn" (click)="purgeProgress()">Start over</button>
	</div>

	<div *ngIf="showRelatedLinks">
		<div class="links-title">Related Links</div>
		<div class="links" *ngFor="let link of relatedLinks" [innerHTML]="link"></div>
	</div>
</ng-container>

<ng-container *ngIf="currentProgressStep === 2">
	<app-location-selection [selectedLatLng]="selectedLatLng" [problemLocation]="problemLocation"
		[isErrorPresentOnPage]="isErrorPresentOnPage" [selectedProblemMenuItem]="selectedProblemMenuItem"
		(selectedCoordinates)="setSelectedCoordinates($event)"
		(selectedLocationNameOrigin)="setSelectedLocationNameOrigin($event)"
		(selectedLocationName)="setSelectedLocationName($event)"></app-location-selection>

	<div class="navButton" id="navBtn">
		<button class="backBtn" (click)="goToPreviousStep()">&lt; Back</button>
		<!-- <button class="NextBtn" (click)="goToNextStep()"
            [disabled]="selectedLatLng === null || (selectedLatLng.lat === 0 && selectedLatLng.lng === 0)">
            Next &gt; </button> -->
		<button class="NextBtn" (click)="goToNextStep()">Next &gt;</button>
	</div>
	<div class="reviewBtn">
		<button class="reviewSubmissionBtn" (click)="goToStep(5)"
			*ngIf="submissionPageViewed && problemAnswersBypassable">Done editing</button>
	</div>
</ng-container>

<ng-container *ngIf="currentProgressStep === 3">
	<app-details-entry [detailsText]="problemDetails" [photoList]="problemPhotos"
		[shouldTriggerReRender]="shouldTriggerReRender" [problemRelatedQuestions]="problemRelatedQuestions"
		[isErrorPresentOnPage]="isErrorPresentOnPage" (problemDetails)="setProblemDetails($event)"
		(addPhoto)="addPhoto($event)" (removePhoto)="removePhoto($event)"
		(setAnsweredProblemQuestions)="setAnsweredProblemQuestions($event)"
		(resetTriggerReRender)="resetTriggerReRender()">
	</app-details-entry>
	<div class="navButton" id="navBtn">
		<button class="backBtn" (click)="goToPreviousStep()">&lt; Back</button>
		<!-- <button class="NextBtn" (click)="goToNextStep()"
            [disabled]="(problemRelatedQuestions.length === 0 && problemDetails.length === 0) || !problemAnswersBypassable">Next
            &gt;</button> -->
		<button class="NextBtn" (click)="goToNextStep()">Next &gt;</button>
	</div>
	<div class="reviewBtn">
		<button class="reviewSubmissionBtn" (click)="goToStep(5)"
			*ngIf="submissionPageViewed && problemAnswersBypassable">Done editing</button>
	</div>
</ng-container>

<ng-container *ngIf="currentProgressStep === 4">
	<app-contact-entry [contactDetails]="contactInfo" [addSecondPhone]="addSecondPhone" [addThirdPhone]="addThirdPhone"
		[contactInfoRequired]="contactInfoRequired" [canCreateCodeCase]="canCreateCodeCase"
		[isErrorPresentOnPage]="isErrorPresentOnPage" [nameAddressEmailReqOnly]="nameAddressEmailReqOnly"
		[nameEmailReqOnly]="nameEmailReqOnly" (newContact)="setProblemContactInfo($event)"
		(addPhoneNumber)="addExtraPhoneNumber()" (removePhoneNumber)="removeExtraPhoneNumber($event)"
		(contactFormValidState)="setContactFormValidState($event)">
	</app-contact-entry>
	<div class="navButton contactPageBtn" id="navBtn">
		<button class="backBtn" (click)="goToPreviousStep()" tabindex="3">&lt; Back</button>
		<!-- <button class="NextBtn" (click)="goToNextStep()" [disabled]="!contactInfoValid" tabindex="2">Review &gt;</button> -->
		<button class="NextBtn" (click)="goToNextStep()" tabindex="2">Review &gt;</button>
	</div>
	<div class="microcopy privacyInformation">
		Information is collected under the authority of the Freedom of Information and Protection of Privacy Act,
		Section 26 (c)(d). Contact the
		Privacy Head at records&#64;dnv.org for questions about your privacy.
	</div>
</ng-container>

<ng-container *ngIf="currentProgressStep === 5">
	<app-submission-review [selectedProblemMenuItem]="selectedProblemMenuItem" [problemDetails]="problemDetails"
		[problemPhotos]="problemPhotos" [contactInfo]="contactInfo" [selectedLatLng]="selectedLatLng"
		[problemLocation]="problemLocation" [problemQuestions]="problemRelatedQuestions"
		(proceedToStep)="goToStep($event)"></app-submission-review>
	<div class="navButton" id="navBtn">
		<button class="backBtn" (click)="goToPreviousStep()">&lt; Back</button>
		<button class="NextBtn" (click)="submitNewProblem()">Submit</button>
	</div>
</ng-container>

<ng-container *ngIf="currentProgressStep === 6">
	<app-submission-complete [contactInfo]="contactInfo"></app-submission-complete>
	<div class="navButton" id="navBtn">
		<button class="NextBtn startOverBtn" (click)="purgeProgress()">Back to Home</button>
	</div>
</ng-container>

<ng-container *ngIf="currentProgressStep === 7">
	<app-system-error-msg (goToBeginning)="purgeProgress()"></app-system-error-msg>
	<button class="NextBtn startOverBtn" (click)="purgeProgress()">Back to Home</button>
</ng-container>

<div class="microcopy googleRecaptchaInfo">
	This site is protected by reCAPTCHA Enterprise and the Google
	<a href="https://policies.google.com/privacy">Privacy Policy</a> and <a
		href="https://policies.google.com/terms">Terms of Service</a> apply.
</div>

<select (change)="devProgressionStep($event)" *ngIf="isDev" class="devPageSelectBox">
	<option value="1">ProblemSelection</option>
	<option value="1.5">ProblemSelectionError</option>
	<option value="2">LocationSelection</option>
	<option value="3">DetailsInput</option>
	<option value="4">ContactDetailsInput</option>
	<option value="5">ReviewPage</option>
	<option value="6">SubmissionComplete</option>
	<option value="7">SystemError</option>
</select>

<ng-template #restoreModal let-modal>
	<div class="modal-heading">Continue your report?<span (click)="closeRestoreModal(false)">X</span></div>
	<div class="modal-body">
		<div class="textEntry">
			<span> We noticed you were reporting a problem, and the process was interrupted. Would you like to continue
				where you left off? </span>
		</div>

		<div class="progressToRestore">
			<div class="dataRestorable" [innerHTML]="restorableHTMLContent"></div>
		</div>

		<div class="modal-btns">
			<button type="button" class="btn restoreBtn" (click)="closeRestoreModal(true)">Continue</button>
			<button type="button" class="btn cancelBtn" (click)="closeRestoreModal(false)">Cancel</button>
		</div>
	</div>
</ng-template>